export default {
	updateStatisticsLocales(state, locales) {
		state.statistics.locales = locales;
	},
};
